/* ENDEX GROUP — global.js | vanilla, no deps */
(function(){
  'use strict';
  var money = window.EndexFormatMoney || function(c){return '$'+(c/100).toFixed(2);};

  /* ---- focus trap ---- */
  function trap(panel){
    var f=panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if(!f.length)return function(){};
    var first=f[0],last=f[f.length-1];
    function on(e){
      if(e.key!=='Tab')return;
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
    panel.addEventListener('keydown',on);
    return function(){panel.removeEventListener('keydown',on);};
  }

  /* ---- generic overlay (mobile nav + cart) ---- */
  function Overlay(root){
    if(!root)return null;
    var release,lastFocus;
    function open(){
      lastFocus=document.activeElement;
      root.setAttribute('open','');
      document.documentElement.style.overflow='hidden';
      var panel=root.querySelector('[data-panel]');
      release=trap(panel);
      var f=panel.querySelector('[data-autofocus]')||panel.querySelector('button,a,input');
      if(f)setTimeout(function(){f.focus();},60);
      document.addEventListener('keydown',esc);
    }
    function close(){
      root.removeAttribute('open');
      document.documentElement.style.overflow='';
      if(release)release();
      document.removeEventListener('keydown',esc);
      if(lastFocus&&lastFocus.focus)lastFocus.focus();
    }
    function esc(e){if(e.key==='Escape')close();}
    root.querySelectorAll('[data-close]').forEach(function(b){b.addEventListener('click',close);});
    return {open:open,close:close,root:root};
  }

  var nav=Overlay(document.getElementById('mnav'));
  var cart=Overlay(document.getElementById('cart-drawer'));
  var menuBtn=document.getElementById('menu-toggle');
  if(menuBtn&&nav)menuBtn.addEventListener('click',nav.open);

  /* ---- cart ---- */
  var countEls=document.querySelectorAll('[data-cart-count]');
  function setCount(n){
    countEls.forEach(function(el){el.textContent=n; el.hidden=(n<=0);});
  }
  function renderCart(state){
    var body=document.getElementById('cart-body');
    if(!body)return;
    setCount(state.item_count);
    if(!state.item_count){
      body.innerHTML='<div class="cart__empty"><p class="mono">Manifest empty.</p><p>Nobody on the list yet.</p></div>';
      var foot=document.getElementById('cart-foot'); if(foot)foot.hidden=true;
      return;
    }
    var foot=document.getElementById('cart-foot'); if(foot)foot.hidden=false;
    var html='';
    state.items.forEach(function(it){
      html+='<div class="citem" data-key="'+it.key+'">'
        +(it.image?'<img loading="lazy" src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2')+'" alt="" width="64" height="80">':'<span></span>')
        +'<div><div class="citem__t">'+it.product_title+'</div>'
        +(it.variant_title&&it.variant_title!=='Default Title'?'<div class="citem__m mono mono--sm">'+it.variant_title+'</div>':'')
        +'<div class="citem__m mono mono--sm">Qty '+it.quantity+'</div>'
        +'<button class="citem__rm mono mono--sm" data-remove="'+it.key+'">Remove</button></div>'
        +'<div class="mono">'+money(it.final_line_price)+'</div></div>';
    });
    body.innerHTML=html;
    var sub=document.getElementById('cart-sub'); if(sub)sub.textContent=money(state.total_price);
    body.querySelectorAll('[data-remove]').forEach(function(b){
      b.addEventListener('click',function(){change(b.getAttribute('data-remove'),0);});
    });
  }
  function fetchCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart);}
  function change(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
  }
  window.EndexCartRefresh=fetchCart;

  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-add-to-cart]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('[type=submit]');
    if(btn){btn.setAttribute('disabled','');btn.dataset.label=btn.textContent;btn.innerHTML='<span class="spinner"></span>';}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok){throw res.j;}
        fetchCart();
        if(cart)cart.open();
      })
      .catch(function(err){
        var m=form.querySelector('[data-form-error]');
        if(m){m.textContent=(err&&err.description)||'Unable to add.';m.hidden=false;}
      })
      .finally(function(){
        if(btn){btn.removeAttribute('disabled');btn.textContent=btn.dataset.label||'Add';}
      });
  });

  var cartOpeners=document.querySelectorAll('[data-cart-open]');
  cartOpeners.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();fetchCart();if(cart)cart.open();});});

  /* ---- qty steppers ---- */
  document.addEventListener('click',function(e){
    var s=e.target.closest('[data-qty-step]');
    if(!s)return;
    var input=s.parentElement.querySelector('input');
    var v=parseInt(input.value||'1',10)+parseInt(s.getAttribute('data-qty-step'),10);
    input.value=Math.max(1,v);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---- PDP gallery (main image + thumbs, follows variant) ---- */
  var frames=document.querySelectorAll('[data-media-id]');
  var thumbs=document.querySelectorAll('[data-thumb]');
  function showMedia(id){
    if(!id)return;
    frames.forEach(function(f){f.classList.toggle('is-active',f.getAttribute('data-media-id')===id);});
    thumbs.forEach(function(t){t.classList.toggle('is-active',t.getAttribute('data-thumb')===id);});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){showMedia(t.getAttribute('data-thumb'));});});

  /* ---- PDP variants ---- */
  document.querySelectorAll('[data-product-form]').forEach(function(root){
    var data=JSON.parse(root.querySelector('[data-variants]').textContent);
    var idInput=root.querySelector('[name="id"]');
    var priceEl=root.querySelector('[data-pdp-price]')||document.querySelector('[data-pdp-price]');
    var addBtn=root.querySelector('[data-add-label]');
    var options=[];
    root.querySelectorAll('[data-opt-index]').forEach(function(g){options[+g.getAttribute('data-opt-index')]=null;});
    function selected(){
      root.querySelectorAll('[data-swatch][aria-pressed="true"]').forEach(function(b){options[+b.getAttribute('data-opt-index')]=b.value;});
      root.querySelectorAll('select[data-opt-index]').forEach(function(sel){options[+sel.getAttribute('data-opt-index')]=sel.value;});
      return options;
    }
    function match(){
      // Single-variant products (digital items) have no option pickers, so there is nothing to match against.
      if(data.length===1)return data[0];
      var o=selected();
      return data.find(function(v){return v.options.every(function(val,i){return val===o[i];});});
    }
    function update(){
      var v=match();
      if(!v){addBtn.textContent='Unavailable';addBtn.setAttribute('disabled','');return;}
      idInput.value=v.id;
      if(v.media_id)showMedia(String(v.media_id));
      if(priceEl)priceEl.innerHTML=v.price_html||money(v.price);
      if(v.available){addBtn.removeAttribute('disabled');addBtn.textContent=addBtn.dataset.add||'Add to kit';}
      else{addBtn.setAttribute('disabled','');addBtn.textContent='Sold out';}
    }
    root.querySelectorAll('[data-swatch]').forEach(function(b){
      b.addEventListener('click',function(){
        root.querySelectorAll('[data-swatch][data-opt-index="'+b.getAttribute('data-opt-index')+'"]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        update();
      });
    });
    root.querySelectorAll('select[data-opt-index]').forEach(function(s){s.addEventListener('change',update);});
    update();
  });

  /* ---- collection: auto-apply sort + facets ---- */
  var sortSel=document.getElementById('sort-by');
  if(sortSel)sortSel.addEventListener('change',function(){
    var u=new URL(window.location.href);u.searchParams.set('sort_by',sortSel.value);u.searchParams.delete('page');window.location.href=u.toString();
  });
  var facetForm=document.getElementById('facet-form');
  if(facetForm)facetForm.querySelectorAll('input').forEach(function(i){
    i.addEventListener('change',function(){facetForm.submit();});
  });

  fetchCart();
})();
